import { createContext, useContext, ReactNode } from 'react';
import { RealtimeAdapter } from '@/adapters/RealtimeAdapter';
import { SupabaseRealtimeAdapter } from '@/adapters/SupabaseRealtimeAdapter';

// Singleton: one Supabase adapter shared across the app.
// To swap providers, replace this instance at the RealtimeProvider call site.
const defaultAdapter: RealtimeAdapter = new SupabaseRealtimeAdapter();

const RealtimeContext = createContext<RealtimeAdapter>(defaultAdapter);

export const useRealtimeAdapter = (): RealtimeAdapter =>
  useContext(RealtimeContext);

interface RealtimeProviderProps {
  children: ReactNode;
  /** Pass a custom adapter to override the default (useful for tests or future providers). */
  adapter?: RealtimeAdapter;
}

export const RealtimeProvider = ({
  children,
  adapter = defaultAdapter,
}: RealtimeProviderProps) => (
  <RealtimeContext.Provider value={adapter}>
    {children}
  </RealtimeContext.Provider>
);
